import Select, { MultiValue } from 'react-select';

export type Option<T extends string | number> = { value: T; label: string };

export default function MultiSelectDropdown<T extends string | number>({
  options,
  placeHolder,
  width = '300px',
  selectedOptions,
  onSelectionChange,
}: Readonly<{
  options: Option<T>[];
  selectedOptions: MultiValue<Option<T>>;
  placeHolder: string;
  width?: string;
  onSelectionChange: (selected: T[]) => void;
}>) {
  const handleChange = (selected: MultiValue<Option<T>>) => {
    onSelectionChange(selected.map((x) => x.value));
  };

  const styles = {
    container: (provided: any) => ({
      ...provided,
      minWidth: 140,
      maxWidth: 400,
    }),
    indicatorSeparator: (provided: any) => ({
      ...provided,
      display: 'none',
    }),
    dropdownIndicator: (provided: any) => ({
      ...provided,
      color: '#2C6EF2',
    }),
  };

  return (
    <div style={{ width }}>
      <Select<Option<T>, true>
        styles={styles}
        isMulti
        value={selectedOptions}
        onChange={handleChange}
        options={options}
        placeholder={placeHolder}
      />
    </div>
  );
}
